module.exports = __webpack_public_path__ + "static/media/pbb.89767fe1.png";